$('.hamburger-button').on('click', function () {
    $('.hamburger').toggleClass('is-active');
    $('.site-header').toggleClass('opened');
    $('.main-slider').toggleClass('main-slider--opened');
    $('.important-text').toggleClass('important-text--move')
    const logoImg = document.querySelector('.main-logo');
    if ($(window).width() >= 1140) {
        [logoImg.dataset.alternate, logoImg.src] = [logoImg.src, logoImg.dataset.alternate];
    }

});